var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUseredit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M710.72 579.2a378.56 378.56 0 0 0-98.88-39.68A248.32 248.32 0 0 0 745.6 320a253.44 253.44 0 0 0-256-249.6 253.44 253.44 0 0 0-256 249.6 249.6 249.6 0 0 0 133.76 218.88c-275.84 70.72-288 375.04-288 378.24l64 2.24c0-13.76 14.4-331.2 348.16-331.2a376.96 376.96 0 0 1 190.4 45.76zM296 320a189.76 189.76 0 0 1 192-185.6 189.44 189.44 0 0 1 192 185.6 189.44 189.44 0 0 1-192 185.6 189.76 189.76 0 0 1-192-185.6zM834.88 566.72l-264.64 262.72-6.4 133.76 130.24-11.2L960 689.28zM665.6 890.24l-34.56 2.88 1.92-35.84 201.92-200.64 32 32z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUseredit);
export default __webpack_public_path__ + "static/media/useredit.ca78841f6674e099d71a28a159b1a6af.svg";
export { ForwardRef as ReactComponent };